import { EMAIL_REGEX, GENERAL_FORM_CONSTANTS } from "../../../../constants";
import { FormValidationType } from "../../../../types";
import { INCIDENT_DETAILS_CONSTANTS } from "../../../constants";

export const formFieldsValidation: FormValidationType = {
  [INCIDENT_DETAILS_CONSTANTS.INCIDENT_DATE]: {
    required: { value: true },
  },
  [INCIDENT_DETAILS_CONSTANTS.DATE_OF_SUBMISSION]: {
    required: { value: false },
  },
  [INCIDENT_DETAILS_CONSTANTS.TYPE_OF_CLAIM]: {
    required: { value: false },
  },
  [INCIDENT_DETAILS_CONSTANTS.CLAIM_TYPE_DETAILS]: {
    required: { value: false },
  },
  [INCIDENT_DETAILS_CONSTANTS.CLAIM_TYPE_ID]: {
    required: { value: true },
  },
  [INCIDENT_DETAILS_CONSTANTS.CLAIM_TYPE_DESCRIPTION]: {
    required: { value: false },
  },
  [INCIDENT_DETAILS_CONSTANTS.TOTAL_CLAIM_CURRENCY_DETAILS]: {
    required: { value: false },
  },
  [INCIDENT_DETAILS_CONSTANTS.TOTAL_CLAIM_CURRENCY_CODE]: {
    required: { value: true },
  },
  [INCIDENT_DETAILS_CONSTANTS.TOTAL_CLAIM_VALUE]: {
    required: { value: true },
    maxCharacters: { value: 23 },
  },
  [INCIDENT_DETAILS_CONSTANTS.EXPECTED_ARRIVAL_DATE]: {
    required: { value: true },
  },
  [INCIDENT_DETAILS_CONSTANTS.LOCATION_OF_INCIDENT]: {
    required: { value: true },
    maxCharacters: { value: 8000 },
  },
  [INCIDENT_DETAILS_CONSTANTS.DETAILED_INCIDENT_SUMMARY]: {
    required: { value: true },
    maxCharacters: { value: 8000 },
  },
  [INCIDENT_DETAILS_CONSTANTS.POLICE_REPORT_AVAILABLE]: {
    required: { value: false },
  },
  [INCIDENT_DETAILS_CONSTANTS.CARGO_OR_PROPERTY_LOCATION]: {
    required: { value: false },
    maxCharacters: { value: 8000 },
  },
  [INCIDENT_DETAILS_CONSTANTS.CONTACT_DETAILS]: {
    required: { value: false },
  },
  [INCIDENT_DETAILS_CONSTANTS.CONTACT_NAME]: {
    required: { value: false },
    maxCharacters: { value: 100 },
  },
  [INCIDENT_DETAILS_CONSTANTS.CONTACT_PHONE_NUMBER]: {
    required: { value: false },
    maxCharacters: { value: 100 },
    matchRegExp: {
      value: new RegExp(GENERAL_FORM_CONSTANTS.PHONE_REGEX),
    },
  },
  [INCIDENT_DETAILS_CONSTANTS.CONTACT_EMAIL_ADDRESS]: {
    required: { value: false },
    maxCharacters: { value: 150 },
    matchRegExp: {
      value: new RegExp(EMAIL_REGEX),
    },
  },
  [INCIDENT_DETAILS_CONSTANTS.ADDITIONAL_INFORMATION]: {
    required: { value: false },
    maxCharacters: { value: 8000 },
  },
};
